/* WAKA PDP — size selection, kit toggles, live total, gallery. No framework. */
(function () {
  var pdp = document.getElementById('WakaPdp'); if (!pdp) return;
  var price = document.getElementById('WakaPrice');
  var vid = document.getElementById('WakaVariantId');
  var stock = document.getElementById('WakaStock');
  var conf = document.getElementById('WakaConfidence');
  var ctaLabel = pdp.querySelector('[data-cta-label]');
  var ctaTotal = pdp.querySelector('#WakaCta [data-cta-total]');   // the CTA button's total (specific — there's also a summary total)
  var summaryTotal = document.getElementById('WakaTotal');          // order-summary total above the CTA
  var lineItem = document.getElementById('WakaLineItem');           // board line-item (before add-ons)
  var sizes = pdp.querySelectorAll('.size');
  var current = { price: 0, available: true };
  function money(s){ return parseFloat((s||'').replace(/[^0-9.]/g,'')) || 0; }
  function fmt(n){ return '$' + n.toLocaleString(); }
  function accessories(){ var sum=0; pdp.querySelectorAll('.kit-toggle:checked').forEach(function(c){ sum += money(c.dataset.price); }); return sum; }
  function refreshTotal(){
    var total = current.price + accessories();
    ctaTotal.textContent = fmt(total);
    if (summaryTotal) summaryTotal.textContent = fmt(total);
    if (lineItem) lineItem.textContent = fmt(current.price);
    // waka-inventory.js is authoritative for the live, market-aware CTA mode.
    var mode = pdp.dataset.ctaMode;
    if (mode === 'notify'){ ctaLabel.firstChild.textContent = 'Notify me when available'; ctaTotal.style.display = 'none'; return; }
    ctaTotal.style.display = '';
    if (mode === 'preorder'){ ctaLabel.firstChild.textContent = 'Pre-order · '; return; }
    if (mode === 'add'){ ctaLabel.firstChild.textContent = 'Add to cart · '; return; }
    ctaLabel.firstChild.textContent = (current.available ? 'Add to cart' : 'Pre-order') + ' · ';
  }
  sizes.forEach(function(btn){
    btn.addEventListener('click', function(){
      sizes.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      vid.value = btn.dataset.variantId;
      current.price = money(btn.dataset.price);
      current.available = btn.dataset.instock === 'true';
      price.textContent = btn.dataset.price;
      var lineSize = document.getElementById('WakaLineSize');
      if (lineSize && btn.dataset.size) lineSize.textContent = ' · ' + btn.dataset.size;
      ['len','wid','wt','rider','fits'].forEach(function(k){
        var el = pdp.querySelector('[data-spec=\'' + k + '\']');
        if (el) el.textContent = btn.dataset[k] || '';
      });
      var ship = stock.dataset.shipdate;
      var preNote = stock.dataset.preorderNote;
      if (current.available){
        stock.classList.remove('pre');
        stock.innerHTML = '<span class="sdot"></span><span><b>In stock</b> · ships now</span>';
        conf.textContent = conf.dataset.instock || '30-day returns';
      } else {
        stock.classList.add('pre');
        stock.innerHTML = '<span class="sdot"></span><span><b>Pre-order</b>' + (preNote ? ' · ' + preNote : '') + (ship ? ' · ' + ship : '') + ' · pre-orders ship first</span>';
        conf.textContent = conf.dataset.preorder || 'Pre-orders ship first · 30-day returns';
      }
      syncKitRec(btn.dataset.size);
      refreshTotal();
      // tell waka-inventory.js to fetch live, market-specific status for this variant
      document.dispatchEvent(new CustomEvent('waka:variant', { detail: { variantId: btn.dataset.variantId, available: current.available } }));
    });
  });

  // Recommended accessory size follows the selected board volume (data-fits on
  // .kit-var, from the waka.fits_volumes variant metafield). First match wins.
  // A size the rider picked by hand (.kit-var.on) is never overridden.
  function syncKitRec(sizeVal){
    var vol = parseInt(sizeVal, 10);
    if (isNaN(vol)) return;
    pdp.querySelectorAll('.kit-row').forEach(function(row){
      var vars = row.querySelectorAll('.kit-var');
      if (!vars.length) return;
      var rec = null;
      vars.forEach(function(b){
        if (rec) return;
        var fits = (b.dataset.fits || '').split(',');
        if (fits.indexOf(String(vol)) > -1) rec = b;
      });
      if (!rec) return; // no fits data — leave the Liquid-rendered default alone
      vars.forEach(function(b){
        var on = b === rec;
        b.classList.toggle('rec', on);
        var label = b.dataset.label || b.textContent.replace(' ★', '');
        b.textContent = on ? label + ' ★' : label;
      });
      if (!row.querySelector('.kit-var.on')){
        var toggle = row.querySelector('.kit-toggle');
        if (toggle){
          toggle.dataset.id = rec.dataset.varId;
          if (rec.dataset.varPrice) toggle.dataset.price = rec.dataset.varPrice;
        }
        var priceEl = row.querySelector('.kit-price:not(.inc)');
        if (priceEl && rec.dataset.varPrice) priceEl.textContent = '+' + rec.dataset.varPrice;
      }
    });
  }
  pdp.querySelectorAll('.kit-toggle').forEach(function(c){
    c.addEventListener('change', function(){
      var row = c.closest('.kit-row'); row.classList.toggle('on', c.checked);
      var chk = row.querySelector('.kit-check'); chk.textContent = c.checked ? '✓' : ''; chk.classList.toggle('on', c.checked);
      if (!c.checked){ row.querySelectorAll('.kit-var').forEach(function(b){ b.classList.remove('on'); }); }
      refreshTotal();
    });
  });
  // accessory size variants: inline & selectable — picking one checks the row (refresh-6)
  pdp.querySelectorAll('.kit-vars-inline').forEach(function(group){
    var row = group.closest('.kit-row'); if (!row) return;
    var toggle = row.querySelector('.kit-toggle');
    group.querySelectorAll('.kit-var').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        group.querySelectorAll('.kit-var').forEach(function(b){ b.classList.remove('on'); });
        btn.classList.add('on');
        // keep the row's "+$…" label in sync with the picked size (2026-07-15
        // "Med→Large doesn't change the price" bug — total updated, label didn't)
        var priceEl = row.querySelector('.kit-price:not(.inc)');
        if (priceEl && btn.dataset.varPrice) priceEl.textContent = '+' + btn.dataset.varPrice;
        if (toggle){
          toggle.dataset.id = btn.dataset.varId;
          if (btn.dataset.varPrice) toggle.dataset.price = btn.dataset.varPrice;
          if (!toggle.checked){ toggle.checked = true; toggle.dispatchEvent(new Event('change', { bubbles: true })); }
          else { refreshTotal(); setTimeout(syncBar, 0); } // syncBar: sticky buy bar shares the same staleness
        }
      });
    });
  });

  // ---- gallery: thumbnail rail + direct image nav + expand/lightbox + swipe (refresh-6) ----
  var rail = document.getElementById('WakaThumbs');
  var galleryMain = document.getElementById('WakaGalleryMain');
  var galleryIndex = document.getElementById('WakaGalleryIndex');
  var prevBtn = document.getElementById('WakaThumbPrev');
  var nextBtn = document.getElementById('WakaThumbNext');
  var imgPrev = document.getElementById('WakaImgPrev');
  var imgNext = document.getElementById('WakaImgNext');
  var expandBtn = document.getElementById('WakaExpand');
  var mainBox = galleryMain ? galleryMain.parentNode : null;
  var gthumbs = rail ? Array.prototype.slice.call(rail.querySelectorAll('button')) : [];
  var activeImg = 0;
  var lbx = document.getElementById('WakaLightbox');
  var lbxImg = document.getElementById('WakaLbxImg');
  var lbxIndex = document.getElementById('WakaLbxIndex');
  function syncArrows(){
    if (!rail) return;
    var overflow = rail.scrollWidth > rail.clientWidth + 2;
    if (prevBtn) prevBtn.disabled = !overflow || rail.scrollLeft <= 2;
    if (nextBtn) nextBtn.disabled = !overflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  }
  function updateLbx(){
    if (!lbxImg || !gthumbs.length) return;
    var t = gthumbs[activeImg];
    lbxImg.src = t.dataset.full || t.dataset.src;
    if (lbxIndex) lbxIndex.textContent = activeImg + 1;
  }
  // The main <img> is seeded by Liquid with a responsive `srcset` for the
  // FEATURED image. With `srcset` present the browser ignores `src` entirely —
  // so assigning `src` alone never changes the rendered photo (the 2026-07-12
  // "thumbnails/arrows don't change the image" bug). Rebuild the srcset for the
  // newly selected media from its CDN URL (Shopify image_url URLs carry an
  // explicit `width=` param we can swap); if the URL has no width param, drop
  // srcset so `src` wins.
  function srcsetFor(url){
    if (!url || !/[?&]width=\d+/.test(url)) return '';
    return [600, 900, 1200, 1600, 2000].map(function(w){
      return url.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
    }).join(', ');
  }
  function selectImg(i){
    if (!gthumbs.length) return;
    activeImg = (i + gthumbs.length) % gthumbs.length;
    var t = gthumbs[activeImg];
    gthumbs.forEach(function(b){ b.classList.remove('active'); });
    t.classList.add('active');
    if (galleryMain){
      var ss = srcsetFor(t.dataset.src);
      if (ss) galleryMain.setAttribute('srcset', ss);
      else galleryMain.removeAttribute('srcset');
      galleryMain.src = t.dataset.src;
    }
    if (galleryIndex) galleryIndex.textContent = t.dataset.index || (activeImg + 1);
    if (rail) rail.scrollTo({ left: t.offsetLeft - rail.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    if (lbx && lbx.classList.contains('open')) updateLbx();
  }
  function openLbx(){ if (!lbx) return; updateLbx(); lbx.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeLbx(){ if (!lbx) return; lbx.classList.remove('open'); document.body.style.overflow = ''; }
  gthumbs.forEach(function(t, i){ t.addEventListener('click', function(){ selectImg(i); }); });
  if (rail){
    rail.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    if (prevBtn) prevBtn.addEventListener('click', function(){ rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function(){ rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); });
    syncArrows();
  }
  if (imgPrev) imgPrev.addEventListener('click', function(){ selectImg(activeImg - 1); });
  if (imgNext) imgNext.addEventListener('click', function(){ selectImg(activeImg + 1); });
  if (galleryMain) galleryMain.addEventListener('click', openLbx);
  if (expandBtn) expandBtn.addEventListener('click', openLbx);
  if (mainBox){
    var tx = null;
    mainBox.addEventListener('touchstart', function(e){ tx = e.touches[0].clientX; }, { passive: true });
    mainBox.addEventListener('touchend', function(e){ if (tx == null) return; var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) selectImg(activeImg + (dx < 0 ? 1 : -1)); tx = null; });
  }
  if (lbx){
    var lbxPrev = document.getElementById('WakaLbxPrev');
    var lbxNext = document.getElementById('WakaLbxNext');
    var lbxClose = document.getElementById('WakaLbxClose');
    if (lbxPrev) lbxPrev.addEventListener('click', function(){ selectImg(activeImg - 1); });
    if (lbxNext) lbxNext.addEventListener('click', function(){ selectImg(activeImg + 1); });
    if (lbxClose) lbxClose.addEventListener('click', closeLbx);
    lbx.addEventListener('click', function(e){ if (e.target === lbx) closeLbx(); });
    document.addEventListener('keydown', function(e){
      if (!lbx.classList.contains('open')) return;
      if (e.key === 'Escape') closeLbx();
      else if (e.key === 'ArrowRight') selectImg(activeImg + 1);
      else if (e.key === 'ArrowLeft') selectImg(activeImg - 1);
    });
  }

  // ---- sticky buy bar: show whenever the main CTA is off-screen (refresh-6) ----
  var buyBar = document.getElementById('WakaBuyBar');
  var realCta = document.getElementById('WakaCta');
  var barCta = document.getElementById('WakaBarCta');
  var barPrice = document.getElementById('WakaBarPrice');
  var barSize = document.getElementById('WakaBarSize');
  var barViento = document.getElementById('WakaBarViento');
  function syncBar(){
    if (barPrice && ctaTotal) barPrice.textContent = ctaTotal.textContent;
    var lbl = (ctaLabel && ctaLabel.textContent) || '';
    if (barCta) barCta.firstChild.textContent = lbl.indexOf('Pre-order') > -1 ? 'Pre-order' : (lbl.indexOf('Notify') > -1 ? 'Notify me' : 'Add to cart');
    var act = pdp.querySelector('.size.active'); var l = act ? act.querySelector('.l') : null;
    if (barSize && l) barSize.textContent = ' · ' + l.textContent;
  }
  if (buyBar && realCta && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      var on = !entries[0].isIntersecting;
      buyBar.classList.toggle('on', on);
      buyBar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('pdp-buybar-on', on);
    }, { threshold: 0 });
    io.observe(realCta);
  }
  if (barCta && realCta) barCta.addEventListener('click', function(){ realCta.click(); });
  if (barViento) barViento.addEventListener('click', function(){ if (window.Viento) window.Viento.open(); });
  pdp.querySelectorAll('.size').forEach(function(b){ b.addEventListener('click', function(){ setTimeout(syncBar, 0); }); });
  pdp.querySelectorAll('.kit-toggle').forEach(function(c){ c.addEventListener('change', function(){ setTimeout(syncBar, 0); }); });

  pdp.querySelectorAll('[data-viento-ask]').forEach(function(b){ b.addEventListener('click', function(){ if (window.Viento) window.Viento.ask(b.dataset.vientoAsk); }); });
  var active = pdp.querySelector('.size.active');
  if (active){ current.price = money(active.dataset.price); current.available = active.dataset.instock === 'true'; syncKitRec(active.dataset.size); }
  refreshTotal();
  syncBar();
})();
